import { viewId, table, restApiKey } from '../../../../_constants/Code'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { getDynamoDB, getStandardFormatUsageItems } from '../../../../common/utils/DynamoDbUtils'
import { httpPost } from '../../../../services/api/AmplifyApi'

/**
 * マスター情報をDynamoDBから取得する関数
 *
 * @async
 * @param {string} corporationNumber - 法人番号
 * @returns {Promise<Object | null>} マスター情報の最初の要素、存在しない場合はnull
 */
export async function fetchMaster(corporationNumber) {
  let master = await getDynamoDB(
    table.Master,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber, MasterId: viewId.segmentInfo },
    null
  )
  return master[0]
}

/**
 * セグメント情報をDynamoDBから取得する関数
 *
 * @async
 * @param {string} corporationNumber - 法人番号
 * @returns {Promise<Object[]>} セグメント情報の配列
 */
export async function fetchSegment(corporationNumber) {
  let segment = await getDynamoDB(
    table.Segment,
    null,
    corporationNumber,
    { CorporationNumber: corporationNumber },
    null
  )
  return segment
}

/**
 * 標準フォーマット利用項目管理を取得する関数
 *
 * @async
 * @param {string} corporationNumber - 法人番号
 * @param {string} itemCategory - 項目区分（例: "セグメント"）
 * @returns {Promise<StandardFormatUsageItems[]>} 標準フォーマット利用項目管理の配列
 */
export async function fetchStandardFormatUsageItems(corporationNumber, itemCategory) {
  let standardFormatUsageItems = await getStandardFormatUsageItems(
    corporationNumber,
    {
      CorporationNumber: corporationNumber
    },
    {
      ItemCategory: itemCategory
    },
    null
  )

  return standardFormatUsageItems
}

/**
 * セグメント情報を更新するAPIを呼び出す関数
 *
 * @async
 * @param {string} corporationNumber - 法人番号
 * @param {Object[]} payload - 更新対象のセグメントデータ配列
 * @returns {Promise<any>} API呼び出しのレスポンス
 */
export async function updateSegment(corporationNumber, payload) {
  const requestPayload = {
    corporation_number: corporationNumber,
    table_data: payload
  }

  const init = {
    headers: {},
    body: requestPayload
  }

  return httpPost(restApiKey.CHROFY_REST_API, PathInfoList.Resource.updateSegment(corporationNumber), init)
}
